<template>
  <div style="word-wrap: break-word; word-break: break-all;">
    <!-- 搜索及排序功能区 -->
    <div class="doclist-typelist-function" style="position: relative">
      <div style="
        background: #f9f9f9;
        width:746px;
        height:9px;
        position: absolute;
        left: 0;
        top: -5px;
        z-index: 4;
      "></div>
      <div style="
        background: #f9f9f9;
        width:746px;
        height:20px;
        position: absolute;
        left: 0;
        top: 41px;
        z-index: 4;
      "></div>
      <div class="search-select">
        <el-select
          v-model="searchtext"
          filterable
          remote
          reserve-keyword
          placeholder="请输入问题标题"
          :remote-method="searchPostsList"
          style="width:746px;box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);border-radius: 0px;height:46px;border:0px !important"
          :loading="loading" @change="postChangeChoose">
          <el-option
            v-for="item in postsList"
            :key="item.id"
            :label="item.articleTitle"
            :value="item.id">
          </el-option>
        </el-select>
        <img class="search-img" alt="查找" height="13px" width="13px" src="data:image/png;base64,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"/>
      </div>
        <!-- <input type="text" placeholder="请输入要查询的内容" class="k-search" v-model="searchtext"> -->
        <!-- <div class="search-select">
          <div class="description">
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</div>
</div> -->
        <div class="doclist-subscribe" @click="routerHandleAskExport()">
        <!-- <img :src="!subscribeOrNot?'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Mjc2OUI5QTk5RUM0MTFFOUFBQkRBMTAyM0EwQTlDMDgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Mjc2OUI5QUE5RUM0MTFFOUFBQkRBMTAyM0EwQTlDMDgiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyNzY5QjlBNzlFQzQxMUU5QUFCREExMDIzQTBBOUMwOCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyNzY5QjlBODlFQzQxMUU5QUFCREExMDIzQTBBOUMwOCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlOGiBcAAADTSURBVHjaYpRNXcFALlCT5Ps/L9eWYe+lZwz1K84zMlAAmCjR7G4owyAnwsMQ56DCQCmgyCEszJBAYGZiGliHUBOMOmTUIaMOGXXIqEOGrUNYQFU5qBZlZiK9FrdQE4OzC321////T7oDnr3/xrD+xEMGhoevP/8faFA078R/JlCj5t+//wMWJc+BIXLp0XsGRkpaaKDoKPTVAbPl01cy/v8/CBLr//+j2XfUIaMOGXXIqENGHTKMHfL03Td4VU5xC40SzaCW1X9gWwbUnqAUAAQYAJIBvR3H/6aUAAAAAElFTkSuQmCC':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NEY1MDc0REU5RUM1MTFFOTlCRUZFQkNDNjYwMDJDNEEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NEY1MDc0REY5RUM1MTFFOTlCRUZFQkNDNjYwMDJDNEEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0RjUwNzREQzlFQzUxMUU5OUJFRkVCQ0M2NjAwMkM0QSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0RjUwNzRERDlFQzUxMUU5OUJFRkVCQ0M2NjAwMkM0QSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pl5Sc0YAAAB3SURBVHja7NahDYAwFITha6lEIgk7MACOhGmYgU26AhKFR3cDEEXWIftgi9eE+yf4cuqMiKCELAqJEEIIIYQQQn4DceOyydS3qKxRAcT0YD1OOD8P6JpadQ3JAruHiJz1ztH9LRKuBMOHRgghhBBCCCGEKPcKMAA/jx3YtXWCYQAAAABJRU5ErkJggg=='"> -->
        我要提问
        </div>
    </div>
    <!-- 帖子类目展示 -->
    <div>
      <el-row>
        <el-col :span="6" v-for="item in postsCategoryList" :key="item.id">
          <div class="category-menu">
            <h4 @click="choosePostsCategory([item.id],[item.fieldName])">{{item.fieldName}}</h4>
            <div v-if="item.children && item.children.length">
              <el-col :span="12" v-for="cate in item.children.slice(0,6)" :key="cate.id">
                <span class="category-menu-child" @click="choosePostsCategory([item.id, cate.id],[item.fieldName, cate.fieldName])">{{cate.fieldName}}</span>
              </el-col>
            </div>
          </div>
        </el-col>
      </el-row>
        <!-- <div>
        </div> -->
    </div>
    <!-- 精品热帖 -->
    <div class="jprt">
      <h3>精品热帖</h3>
      <el-row>
        <el-col :span="12" v-for="item in hotPostsList" :key="item.id">
          <div class="jprt-item" @click="postsDetailHandle(item.id,item)">
            <img class="k-doctype k-supremedoc" :src="BASE_URL + 'img/hot.png'" alt="火">
            <div class="jprt-item-title overell">{{item.articleTitle}}</div>
            <p class="jprt-item-content">{{item.postsName}}&nbsp;上传&nbsp;|&nbsp;{{item.articleCommentCount}}&nbsp;个回复&nbsp;|&nbsp;{{item.articleViewCount||0}}&nbsp;次游览&nbsp;|&nbsp;{{item.createTime}}</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 专家问答 -->
    <div class="k-tecdocument">
      <h2>热门专家</h2>
      <!-- 专家问答一级类目选择区域 -->
      <div class="k-doctypelisthead">
        <ul class="k-doctypelist">
          <li v-for="(item,index) in exportHotTypeList.slice(0,6)" :key="index"
          :class="'overell k-doctypelist-mune '+ (index===currentExportHotIndex?'k-doctypelist-active':'')"
          @click="changeExportIndex(index)" :title="item.fieldName">
            {{item.fieldName}}
          </li>
        </ul>
        <!-- 专家问答列表跳转 -->
        <div class="k-doctypelist-more">
          <span @click="routerHandleAskExport()">更多</span>
          <img alt="更多" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODZEN0MyOEM5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODZEN0MyOEQ5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NkQ3QzI4QTlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NkQ3QzI4QjlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrUEepsAAADHSURBVHjajJHBCYUwDEBTwRE8CJ4LevXqAg7gCg7QHeoUjuHBEbxJ7x2jIKWHfOpB8NumDaRN4L3SEDZNE9Z1DcuysLIsgYrCg/u+gxACnXMkDMYYmOcZOefob99ba4N5H7nCU+QIryYlfGxKCP4tJkQnDwlR+F+QUmJB7cBvdBzHu9Za0y9v24Zt22Lf96iUwizwPE+MDhgCg3AM/MAU+IJT4APngDecC/pkwzDgdV2writ0XceoJbHjOLCqKmiahkEifgIMACjN8xlwRNSeAAAAAElFTkSuQmCC">
        </div>
      </div>
      <!-- 专家问答主体 -->
      <el-row class="bacfff" :gutter="15" v-if="showExportHotList.length">
          <el-col :span="12" class="margin10" v-for="(item, index) in showExportHotList" :key="index">
            <el-col class="bacf8">
              <el-col :span="8">
                <div class="tpic" @click.stop="routerHandleExportDetail(item)">
                  <img :alt="item.name" :src="item.userAvatarUrl || BASE_URL + 'img/zwt.png'" width="80px" height="80px" style="border-radius：30px">
                </div>
                <div class="ask" @click.stop="routerHandleAskExport(item.id, item.name)">我要提问</div>
              </el-col>
              <el-col :span="16" class="askbox">
                <div class="askbox-font-big">{{item.name}}&nbsp;专家</div>
                <div v-if="item.fileVideoTypeAttributeEntityList" class="askbox-font-label overell">
                  <span v-for="(itemLabel, indexLabel) in item.fileVideoTypeAttributeEntityList" :key="indexLabel">
                    {{itemLabel.typeAttributeValue}}
                  </span>
                </div>
                <div class="askbox-introduction" :title="item.expertIntroduction">{{item.expertIntroduction}}</div>
                <div class="export-info-opt">
                  <div class="export-info-opt-label">
                      <div class="export-about-info handleCursor" @click.stop="routerHandleExportDetail(item)">
                        <div class="info-count">{{item.questionCount||0}}</div>
                        <div>被提问数</div>
                    </div>
                    <div class="export-about-info handleCursor" @click.stop="routerHandleExportDetail(item)">
                        <div class="info-count">{{item.replyCount||0}}</div>
                        <div>个回复数</div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-col>
          </el-col>
          <el-col>
    <!-- 分页 -->
    <div class="doclist-pagination">
      <!--  v-if="doclist === null || doclist.length !== 0" -->
        <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
        <li :class="item === currentPage?'pageactive':''" v-for="(item, index) in pageList" :key="index" @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
          </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { expertDetail, expertPutQuestionsTo } from '@/utils/eventTracking'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      searchtext: '', // 检索内容
      loading: false,
      postsList: [], // 检索帖子列表
      exportHotTypeList: [], // 热门专家类目
      currentExportHotIndex: 0, // 当前热门专家类别index
      hotPostsList: [], // 精品热帖
      postsCategoryList: [],
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  computed: {
    // 当前页面显示的
    showExportHotList () {
      if (this.currentPage > 0 && this.currentExportHotIndex > -1 && this.exportHotTypeList[this.currentExportHotIndex]) {
        return this.exportHotTypeList[this.currentExportHotIndex].expertFieldReplyPage.data
      } else {
        return []
      }
    }
  },
  methods: {
    // 检索帖子列表
    searchPostsList (query) {
      if (query !== '') {
        this.loading = true
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserarticle/selectArticleByTitle`, {
          params: {
            articleTitle: query,
            _noLoading: true
          }
        })
          .then(({ data }) => {
            // console.log(data, 'searchPostsList')
            if (data && data.code === 0) {
              this.postsList = data.data || []
            } else {
              this.postsList = []
            }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            this.postsList = []
          })
      } else {
        this.postsList = []
      }
    },
    postChangeChoose () {
      if (this.searchtext) {
        this.postsDetailHandle(this.searchtext)
      }
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        let newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        let newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      // this.currentPage = page
      this.getHotExportList(page)
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        let newCurrentPage = this.jumpTargetPage
        this.changePageTo(newCurrentPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    changeExportIndex (index) {
      if (
        this.exportHotTypeList[index] &&
        this.exportHotTypeList[index].expertFieldReplyPage &&
        this.exportHotTypeList[index].expertFieldReplyPage.data &&
        this.exportHotTypeList[index].expertFieldReplyPage.data.length
      ) {
        this.currentExportHotIndex = index
        this.getHotExportList(1)
      } else {
        this.$message.info(this.exportHotTypeList[index].fieldName + ' 下暂无专家')
      }
      // this.currentPage = 1
    },
    changeExportPage (page) {
      // let page = this.currentPage
      this.totalPage = Math.ceil(this.exportHotTypeList[this.currentExportHotIndex].expertFieldReplyPage.count / 10)
      if (this.totalPage > 5) {
        if (page > 3 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          if (newPageList[newPageList.length - 1] < this.totalPage) {
            this.nextOmit = '...'
          } else {
            this.nextOmit = ''
          }
          if (newPageList[0] > 1) {
            this.lastOmit = '...'
          } else {
            this.lastOmit = ''
          }
          // this.lastOmit = '...'
          // this.nextOmit = '...'
        } else if (page <= 3) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.currentPage = page
        this.lastOmit = ''
        this.nextOmit = ''
      }
    },
    routerHandleAskExport (id, name) {
      if (id) {
        expertPutQuestionsTo(name)
        this.$router.push({
          name: 'askToExpert',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({ name: 'chooseExpert' })
      }
    },
    // 获取热门专家
    getHotExportList (currentPage) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldtype/selectExpertFiledAndFields`, {
        'page': currentPage,
        'limit': 10,
        'fieldTypeId': (this.currentExportHotIndex === -1 || this.exportHotTypeList.length === 0) ? '' : this.exportHotTypeList[this.currentExportHotIndex].id
      })
        .then(({ data }) => {
          let list = data.data || []
          if (this.currentExportHotIndex > -1 && this.exportHotTypeList.length > 0 && this.exportHotTypeList[this.currentExportHotIndex].id) {
            this.exportHotTypeList[this.currentExportHotIndex] = list[0]
          } else {
            if (list.length > 7) {
              list.splice(7)
            }
            this.exportHotTypeList = list
          }
          if (this.currentExportHotIndex > -1) {
            // this.changePageTo(this.currentPage)
            this.changeExportPage(currentPage)
          }
        })
    },
    getPostsCategoryList () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldtype/findDataByTree`)
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.postsCategoryList = data.data || []
          } else {
            this.postsCategoryList = []
          }
        })
    },
    // 跳转对应一级类目的帖子下
    choosePostsCategory (ids, names) {
      this.$router.push({
        name: 'categoryArticle',
        query: {
          categoryIds: ids,
          names: names
        }
      })
    },
    // 获取精品热帖
    getHotPostsList () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserarticle/selectArticlePerfects`, {
        params: {
          count: 6
        }
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.hotPostsList = data.data || []
          } else {
            this.hotPostsList = []
          }
        })
    },
    // 跳转到专家详细页面
    routerHandleExportDetail (item) {
      expertDetail(item.name)
      this.$router.push({
        name: 'exportDetail',
        query: {
          id: item.id,
          uId: item.userId
        }
      })
    },
    postsDetailHandle (id, item) {
      console.log(item)
      this.$router.push({
        name: 'postsDetail',
        query: {
          id: id
        }
      })
    }
  },
  mounted () {
    this.getHotExportList(1)
    this.getPostsCategoryList()
    this.getHotPostsList()

    console.log(this.hotPostsList)
  }
}
</script>

<style scoped>
.handleCursor{
  cursor: pointer;
}
.handleCursor:hover{
  color: #1D65A8;
}
.search-select{
  position: relative;
}
.search-img{
  position: absolute;
  right: 7px;
  top:17px;
}
.category-menu{
  height: 110px;
  padding: 10px 15px;
  background-color: #fff;
  margin-right: 10px;
  margin-bottom: 10px;
}
.category-menu h4{
  margin-bottom: 10px;
}
.category-menu h4,.category-menu-child{
  cursor:pointer;
}
.category-menu h4:hover,.category-menu-child:hover{
  color: #0033ff;
}
/* 我要提问 */
.k-search{
  background-color: #ffffff;
  width: 750px;
  height: 46px;
  border: none;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowYmRhM2E1NS1hNGFiLTRhOWEtOWM1ZS1hYmE4ZGQyZGZmYjYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDNCM0VFRTAwODY4MTFFNzk4OEVCRTY3MDEyREIyMzQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDNCM0VFREYwODY4MTFFNzk4OEVCRTY3MDEyREIyMzQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpkOWQ1OWQ5Ny01YjU0LTQxM2MtOGQ5Mi1jMTc1MmI5OTBkNWYiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo3MWQ4NmI0NS00ZmZjLTExN2EtOWUyMC05NWI5MzMyMTY2MjkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz51oNa0AAAEbUlEQVR42syZaYxMWRiGT9uCQWtbYg2CNiJNYk/40Y0f+CcRMZYgdDOGWENMbB2xa7RGWsSemcSPSUgk1m7hhyWRsYQYBh27FkFbpglT3s99T/scVd11u3TVfZMnVffWrVvvPfWd75zznaTMzEwTg9qDDNAXdObxT6ABeAXegtvgH3AWFICiWH4wPz/f1KjE91LAeJJWznXJpAUYACbx/EWwD+wCJZUxXs3HtdJ6K9lSORUYLk89wEbeZymo5/cG0bb0CLAJNHfOfwLnQCG4wjAoYWhIKzcEnUB3kA56q4aSf2wJmACmg0M/ynRtmnUD/x7IBX+AxxG++4Kvl8ABvpdQGQdmqAZoAw6CPDAXvI8lPKQljjuGX4LfQEewvhzDkfQIrGKHFYOv1Wdy38OgfmVNJ/Mv76/OHQOpYAv4YGJTKR/6Z/6O1UA2VLJf03XBEdBNnVsBhoBi82P1EAxmx7TqA/4CtfyYzmPetZoNfgf/m6qRdOZZ7JRWGcxQUZkeyd5sJfG3wcRH2Wwwq2lgWEWmGzIjWEmILDTx1UxwRh1vZrhGND0fNFNZQka8UJxNS6iMBm943I6hE9a0pLdf1XmJ4acmMboPljutXy+c6Ykcpu2XdpjEKldlqiZs/e9Mj3W+8CHBpv8DW9XxONd0qsrJH8F+EwztVX2qH6cAZaYz1IXnwZOAmL7LSZgoCQzSpnuqCwtNsKT99HLDw+pywExrP1206bbqg9sBM31TvW+lTeup4POAmX6p3tfXphuoD14HzPQbZ/ZZZrok3NMERNrPu0imGwfMdEq4KKjGfGjVKWCmtZ872rTuoWkBM61XTze06bPqg/SAmU53Rusy0yed9VnLgBjuALryvcxBCrTpIjXGy/GYgJgezzmHYTQUu1PT3eriGSzSJFIy6Z+ijveEm0/vVKOPTAGnJtj0LJV+ZQW1L5zpV86idqmev8ZZUn1aoI5zuCj4oqysrG8WtmuNV6MzHNplMVA9zoZrGq8+aIfsW8arJUZcjcs4P91JN+vibHoHM5jNGBKm7ysq1hxirUGvhBfHyfAmZy34p5OOI5oWzdU5EVpmvCpT9SoMie3MWlpS42sTrWlZiQ833jaDbvHCSDeJQVKMOQ0mq3Nv+drUeIXIutGYttkk3fl7ZN/kGpgH6sRoVows4v10sVPKybJb8IzHstWxLVrTdio4lKERUkl/DZdlEuutfZqVpV02Z5bZ6uHl/quNV3C8DkYZr0Rmax4z9U2SotySk5vlOetJ+2OXzdc9F0lRsm1RylG1EaeXaSxVdFVDs9W/xivJHXfOS4l5varHSIyfkoNoN4oOs3PO4VM3VvWI7sSvimkqlw/pKofh8Qt9HmC5456fLTkZlZaztadwEuO3qhpSHa8dQ620nOvlur/djlmZzU8ZhPKJLOsHskVS+UCyX1KLg0IJVxw3mI1O+KxgvWMmu0DTXzpmjRizwAPOwPZU4aBTxI55lGPF1aRQKN518+8lk6AoNJvZbt1nAQYAKkzrc48wsvkAAAAASUVORK5CYII=) no-repeat 715.5px 16.2px;
  background-size: 13px 13px;
}
.k-search::-webkit-input-placeholder {
  color: #bebebe;
  font-size: 14px;
}
.k-search:-moz-placeholder {
  color: #bebebe;
  font-size: 14px;
}
.k-search:-ms-input-placeholder {
  color: #bebebe;
  font-size: 14px;
}
/* 设定整体版心布局 */
.doclist{
  width: 1230px;
  padding: 0 20px;
  margin: 0 auto;
  padding-top: 20px;
  margin-bottom: 20px;
}
/* 列表页标题及类目展示和清空 */
.doclist-title{
  display: flex;
  height: 28px;
  line-height: 28px;
  user-select: none;
  margin-bottom: 20px;
}
.doclist-title h2{
  font-size: 20px;
  color: #333333;
  font-weight: 600;
}
.doclist-categoryone{
  display: flex;
}
.doclist-categoryone img{
  width: 6px;
  height: 11px;
  margin: auto 11px;
}
.doclist-categorytwo{
  display: flex;
}
.doclist-categorytwo img{
  width: 6px;
  height: 11px;
  margin: auto 11px;
}
.doclist-category-box{
  height: 24px;
  display: flex;
  line-height: 24px;
  box-sizing: border-box;
  user-select: none;
  margin: auto 0;
}
.doclist-category-box div:nth-of-type(1){
  flex: 1;
  text-align: center;
  padding: 0 1px;
}
.doclist-category-box div:nth-of-type(2){
  width: 24px;
  cursor: pointer;
}
.doclist-category-cancelone{
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDA3OEFGQjA5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDA3OEFGQjE5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpEMDc4QUZBRTlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEMDc4QUZBRjlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppgy6CQAAAE4SURBVHjajNNNi4JAGAfwTT1Ivp0k0q8hXqKO5iU6+GHNIAg8aVJQJy950RQvQgQFSu4jRts64+z+D8Mjzo9xfGYGruvGcTybzRRF+forx+PxdDrpuk4bhnG9Xs/n82g0EgSBYPb7ve/7ZVmyLEtNp1OGYaqqWq1Wl8uFYIIggEKSJE3TBnVdJ0niOA5I8KZpol/7aRaLxXA4bBg8EyRqoH6xPok1vxgqsyzDmi77lBRFPZ9PrMGwVtq23RpoyXK57BgIhf7rPM9bA7nf70VRoHO6qx0Oh91uBwXP84/Ho93nfD5XVbWXvY0oirAfWGe9XmPlD+sYjuOghuOKlS+GNW2wsmEE0ydpy7I8zyOY9pUsy1EUgYRxPB7Tk8kE7gLBoLJpTxiG2+32drvV/0iappvNBhr7LcAACe08BFMfHcMAAAAASUVORK5CYII=) no-repeat 7.5px 7.5px;
  background-size: 9px 9px;
}
.doclist-category-canceltwo{
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDA3OEFGQjA5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDA3OEFGQjE5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpEMDc4QUZBRTlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEMDc4QUZBRjlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppgy6CQAAAE4SURBVHjajNNNi4JAGAfwTT1Ivp0k0q8hXqKO5iU6+GHNIAg8aVJQJy950RQvQgQFSu4jRts64+z+D8Mjzo9xfGYGruvGcTybzRRF+forx+PxdDrpuk4bhnG9Xs/n82g0EgSBYPb7ve/7ZVmyLEtNp1OGYaqqWq1Wl8uFYIIggEKSJE3TBnVdJ0niOA5I8KZpol/7aRaLxXA4bBg8EyRqoH6xPok1vxgqsyzDmi77lBRFPZ9PrMGwVtq23RpoyXK57BgIhf7rPM9bA7nf70VRoHO6qx0Oh91uBwXP84/Ho93nfD5XVbWXvY0oirAfWGe9XmPlD+sYjuOghuOKlS+GNW2wsmEE0ydpy7I8zyOY9pUsy1EUgYRxPB7Tk8kE7gLBoLJpTxiG2+32drvV/0iappvNBhr7LcAACe08BFMfHcMAAAAASUVORK5CYII=) no-repeat 7.5px 7.5px;
  background-size: 9px 9px;
}
.doclist-category-boxone:hover .doclist-category-cancelone{
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjI5RTEwMEQ5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjI5RTEwMEU5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGMjlFMTAwQjlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGMjlFMTAwQzlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpHD1P0AAAFpSURBVHjaYly4/7a9tkT5otPHbr5iIATS3NRTXNQ71l1kAuqRF+VZkGtrrSGGX0++j1ZNiIGEAKe5qijzS0k3bxNZDjYWH2PZc/fePn7zFZeeYj9dIOPBq89FC04xf5TzvHD/LX6dyHpCe/a//PCdCcg5fP1l8pTDP37/Beqcn4PuWkw9QDYTRA6XTqx6gICZ3zgEwnr05iuaa4Ms5LHqAQJG2dQVyE6y1RSfm2PLwcr8+88/VhYmrHoQjoQDiGvhep68/YqpB4s2IDBQFILoAQIRPg41ST5MNejacr00SwP0gIynb7+CQoiVGehmoMvxaYPrefj6S1DX3pSpR3DpRIQksp6wnn3P338HMi4+eOdlLAvUCQxhYDg/gqUEqDZMPRBpXDpB2nDpwaOTuaS8qjLYAJcerDpP3HrFvGx2Pw8HKx49mDrZWJiY/6v7fvz2q3DeyRcfvuPPb0CdJ2+/BuqZu/c2QIABACZdDnpEyh28AAAAAElFTkSuQmCC) no-repeat 8.5px 6.5px;
  background-size: 9px 9px;
  background-color: #1D65A8;
}
.doclist-category-boxtwo:hover .doclist-category-canceltwo{
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjI5RTEwMEQ5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjI5RTEwMEU5RTFEMTFFOUJFNUJGMkI2RkVGMDE4MkEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGMjlFMTAwQjlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGMjlFMTAwQzlFMUQxMUU5QkU1QkYyQjZGRUYwMTgyQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpHD1P0AAAFpSURBVHjaYly4/7a9tkT5otPHbr5iIATS3NRTXNQ71l1kAuqRF+VZkGtrrSGGX0++j1ZNiIGEAKe5qijzS0k3bxNZDjYWH2PZc/fePn7zFZeeYj9dIOPBq89FC04xf5TzvHD/LX6dyHpCe/a//PCdCcg5fP1l8pTDP37/Beqcn4PuWkw9QDYTRA6XTqx6gICZ3zgEwnr05iuaa4Ms5LHqAQJG2dQVyE6y1RSfm2PLwcr8+88/VhYmrHoQjoQDiGvhep68/YqpB4s2IDBQFILoAQIRPg41ST5MNejacr00SwP0gIynb7+CQoiVGehmoMvxaYPrefj6S1DX3pSpR3DpRIQksp6wnn3P338HMi4+eOdlLAvUCQxhYDg/gqUEqDZMPRBpXDpB2nDpwaOTuaS8qjLYAJcerDpP3HrFvGx2Pw8HKx49mDrZWJiY/6v7fvz2q3DeyRcfvuPPb0CdJ2+/BuqZu/c2QIABACZdDnpEyh28AAAAAElFTkSuQmCC) no-repeat 8.5px 6.5px;
  background-size: 9px 9px;
  background-color: #1D65A8;
}
.doclist-category-boxone:hover{
  border: 1px solid #1D65A8;
  line-height: 22px;
  color: #1D65A8;
}
.doclist-category-boxone:hover div:nth-of-type(1){
  padding: 0
}
.doclist-category-boxTwo:hover div:nth-of-type(1){
  padding: 0
}
.doclist-category-boxtwo:hover{
  border: 1px solid #1D65A8;
  line-height: 22px;
  color: #1D65A8;
}
/* 清空筛选样式 */
.doclist-category-cancelall{
  margin-left: 16px;
  font-size: 16px;
  color: #666666;
  cursor: pointer;
}
/* 剩余大板左右布局 */
.doclist-lastarea{
  display: flex;
}
.doclist-lastarea-l{
  width: 100%;
  padding-left: 30px;
  margin-right: 20px;
  padding-top: 20px;
}
.doclist-lastarea-r{
  flex: 1;
}
/* 左侧一二级类目布局 */
.doclist-typelist{
  margin-bottom: 20px;
}
.doclist-typelist-first{
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #666666;
}
.doclist-typelist-second{
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #666666;
}
.doclist-typelist-first{
  display: flex;
}
.doclist-typelist-first div{
  margin-right: 20px;
}
.doclist-typelist-first ul{
  display: flex;
  flex-wrap: wrap;
}
.doclist-typelist-first ul li{
  margin-right: 20px;
  user-select: none;
  cursor: pointer;
}
.doclist-typelist-second{
  display: flex;
}
.doclist-typelist-second div{
  margin-right: 20px;
}
.doclist-typelist-second ul{
  display: flex;
  flex-wrap: wrap;
}
.doclist-typelist-second ul li{
  margin-right: 20px;
  user-select: none;
  cursor: pointer;
}
.type-active{
  color: #1D65A8;
}
/* 左侧功能区样式 */
.doclist-typelist-function{
  display: flex;
  line-height: 46px;
  margin-bottom: 33px;
}
.doclist-typelist-function img{
  width: 13px;
}
.doclist-typelist-function input{
  width: 600px;
  height: 46px;
  box-sizing: border-box;
  border: 1px solid #d3d3d3;
  text-indent: 20px;
  background: url(data:image/png;base64,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) no-repeat 550px 16px;
  background-size: 16px 16px;
}
.doclist-sort{
  display: flex;
  font-size: 14px;
  margin-left: 30px;
  cursor: pointer;
  user-select: none;
}
.doclist-sort img{
  width: 10px;
  height: 6px;
  margin: auto 0;
  margin-left: 8px;
}
.doclist-sort-active{
  color: #1D65A8;
}
.doclist-sort-deavtive{
  color: #666666;
}
.doclist-subscribe{
  width: 124px;
  height: 46px;
  background: #1D65A8;
  color: #ffffff;
  line-height: 46px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  user-select: none;
  margin-left: 10px;
}
.doclist-subscribe img{
  width: 17px;
  height: 17px;
  margin: 0 auto;
  margin-right: 8px;
  margin-top: -3px;
}
/* 技术文档列表样式 */
.doclist-list li{
  height: 80px;
  margin-bottom: 59px;
  position: relative;
  display: flex;
  user-select: none;
}
.doclist-list-left{
  width: 105px;
}
.doclist-list-authoricon{
  width: 74px;
  height: 74px;
}
.doclist-list-text{
  flex: 1;
}
.doclist-list-text div:nth-of-type(1){
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 22px;
  margin-bottom: 10px;
}
.doclist-list-text div:nth-of-type(2){
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  margin-bottom: 10px;
}
.doclist-list-text div:nth-of-type(3){
  font-size: 12px;
  color: #262626;
  line-height: 17px;
}
.k-doctype{
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  left: 0;
}
.doclist-list-function{
  width: 122px;
  display: flex;
  font-size: 12px;
  color: #1D65A8;
  line-height: 138px;
}
.doclist-list-like{
  flex: 1;
  cursor: pointer;
}
.doclist-list-like img{
  width: 13px;
  height: 12px;
  margin-top: -2px;
}
.doclist-list-download{
  width: 64px;
  cursor: pointer;
}
.doclist-list-download img{
  width: 13px;
  height: 12px;
  margin-top: -2px;
}
/* 分页区域样式 */
.doclist-pagination .pageactive{
  background: #1D65A8;
  color: #ffffff;
}
.doclist-pagination{
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  /* padding-left: 95px; */
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
/* 右侧区域样式 */
/* 上传按钮样式 */
.doclist-upload{
  width: 280px;
  height: 78px;
  background: url(data:image/png;base64,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) no-repeat 69px 28px;
  background-size: 28px 25px;
  background-color: #1D65A8;
  text-indent: 112px;
  line-height: 78px;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
  user-select: none;
}
/* 热门下载推荐样式 */
.doclist-hotdownloads{
  margin: 36px 20px 62px 26px;
}
.doclist-hotdownloads h3{
  margin-top: 0;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 18px;
}
.doclist-hotdownloads ul li{
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  user-select: none;
  cursor: pointer;
}
.doclist-hotdownloads ul li img{
  position: absolute;
  width: 15.5px;
  height: 18px;
  left: 0;
  top: 8px;
}
.doclist-hotdownloads ul li p{
  width: 233px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
}
.doclist-hotdownloads ul li p span{
  display: inline-block;
  width: 23px;
}
/* 热门推荐样式 */
.doclist-hotcommend{
  margin: 0 20px 0 26px;
}
.doclist-hotcommend h3{
  margin-top: 0;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 18px;
}
.doclist-hotcommend ul li{
  display: flex;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  user-select: none;
  cursor: pointer;
}
.doclist-hotcommend ul li div{
  width: 6px;
  height: 6px;
  margin: auto 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #1D65A8;
}
.doclist-hotcommend ul li p{
  margin: 0;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
}
.k-tecdocument{
  background-color: #fff;
  padding: 10px 10px 20px 10px;
}
/* 热门专家 */
.k-tecdocument h2{
  padding-left: 10px;
  font-size: 20px;
  color: #333333;
  font-weight: 500;
  /* color: #262626; */
  margin-bottom: 12px;
}
.k-doctypelist-mune{
  max-width: 100px;
}
.k-doctypelisthead{
  padding-left: 10px;
  display: flex;
  position: relative;
  border-bottom: 1px solid #eee;
}
.k-doctypelist-more{
  position: absolute;
  right: 0;
  font-size: 14px;
  color: #262626;
  display: flex;
  line-height: 32px;
  user-select: none;
  cursor: pointer;
}
.k-doctypelist-more:hover{
  color: #fff;
  background-color: #2b7dca;
}
.k-doctypelist-more img{
  width: 6px;
  height: 11px;
  display: block;
  margin-top: 10px;
  margin-left: 6px;
}
.k-doctypelist{
  display: flex;
  margin-bottom: 19px;
}
.k-doctypelist li{
  width: 96px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.k-doctypelist-active{
  background: #1D65A8;
  color: #ffffff;
}
.tpic{border-radius: 50px; height: 80px; margin: 20px 10px 10px 10px; width: 80px; overflow: hidden;cursor: pointer;}
.ask{border: 1px #1D65A8 solid; text-align: center; line-height: 35px;color: #1D65A8; margin-bottom: 20px}
.ask:hover{background: #1D65A8;color:#ffffff;cursor: pointer;}
/* .bacf8{background: #f8f8f8;} */
.bacfff{
  width: 100%;
  background: #ffffff;
  height: auto;
  margin-top: 0;
}
.margin10{
  /* margin: 10px 0px; */
  border-bottom: 1px solid #eee;
}
.askbox{
  margin-top: 15px;
  text-align: left;
  height: 100%;
}
.askbox-font-big{
  width: 100%;
  font-size: 16px;
  color: #262626;
  height: 22px;
  line-height: 22px;
  /* font-weight: 900; */
  margin-bottom: 5px;
}
.askbox-font-label{
  width: 100%;
  font-size: 14px;
  color: #262626;
  height: 22px;
  line-height: 22px;
  /* font-weight: 900; */
  margin-bottom: 5px;
}
.askbox-introduction{
  height: 36px;
  font-size: 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  width: 100%;
}
.askbox h4{line-height: 30px;}
.askbox span{line-height: 20px; margin-bottom: 20px; height: 45px;}
.askbut {background:#1D65A8; text-align: center; line-height: 40px; color:#ffffff;margin-top: 10px;margin-bottom: 20px;}
.askbut:hover{background: #2b7dca;cursor: pointer;}
/* 精品热帖*/
.jprt{
  background-color: #fff;
  margin-top: 10px;
  margin-bottom: 30px;
  padding-left: 20px;
  padding-top: 30px;
}
.jprt h3{
  font-weight: 500;
  line-height: 28px;
  font-size: 20px;
  color: #333333;
}
.jprt-item{
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 20px 30px 20px;
  border: 1px solid #eee;
  cursor: pointer;
  position: relative;
}
.jprt-item img{
  width: 40px;
  height: 40px;
}
.jprt-item-title{
  font-size: 16px;
  padding-bottom: 20px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.jprt-item-content{
  font-size: 12px;
  height: 12px;
  line-height: 12px;
}
/* 浏览回复数  */
.export-info-opt{
  margin-bottom: 5px;
  width: 100%;
  display: flex;
}
.export-info-introduction{
  font-size: 10px;
  /* height: 12px;
  line-height: 12px; */
}
.export-info-opt-label{
  width: 100%;
  display: inline-block;
  margin-right: 0;
  align-self: right;
  align-items: right;
  padding-right: 0px;
  /* float:right; */
}
.export-about-info{
  display: inline-block;
  text-align: center;
  align-items: center;
  width: 48%;
}
/* /deep/.el-select{
  width:200px;
}
/deep/.el-select .el-input .el-input__inner{
   width: 750px !important;
   color: #0033ff !important;
 } */
 /* .el-select .el-input /deep/{
     width: 500px !important ;
   } */
.data-v-29427d04 .el-input .el-input__inner{
  width: 750px !important;
}
p {
  margin: 0;
}
a {
  color: #333
}
a:hover {
  color: #666
}
h3 {
  margin: 0;
}
h4 {
  margin: 0;
}
</style>
